import { put, call, takeLatest } from 'redux-saga/effects';
import { Types, Creators } from './user-session-duck.js';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import * as Api from './user-session-api.js';
import { jwtDecode } from 'jwt-decode';
import { Creators as GlobalCreators } from '../globals/globals-duck.js';
import toastApiError from 'utils/api-error.js';

export const getState = (state) => state.UserSession;

export function* loginAsync({ values }) {
  try {
    yield put(GlobalCreators.globalsSetLoading(true));
    const response = yield call(Api.login, values);
    if (response?.data?.token) {
      const decodedToken = jwtDecode(response.data.token);

      Cookies.set('authToken', response.data.token, {
        expires: new Date(response.data.expiration),
      });

      yield put(
        Creators.userSessionLoggedIn(
          response.data.token,
          decodedToken.userName,
          decodedToken.expiration,
        ),
      );

      window.location.href = '/management';
    } else {
      toast.error('Erro ao fazer login. Verifique suas credenciais.');
    }
  } catch (error) {
    toastApiError(error);
  } finally {
    yield put(GlobalCreators.globalsSetLoading(false));
  }
}

export default [takeLatest(Types.USER_SESSION_LOGIN_ASYNC, loginAsync)];
